// src/features/whatsapp/pages/WelcomeMessagePage.tsx
// Re-cableado a lealify-base (Inc11): mensaje de bienvenida automático (evento welcome).
// Wrapper delgado sobre EventMessageEditor → /messages/settings. Fuera Firestore.
import React from 'react';
import { HandMetal } from 'lucide-react';
import EventMessageEditor from '../components/EventMessageEditor';

const WelcomeMessagePage: React.FC = () => (
  <EventMessageEditor
    eventKey="welcome"
    title="Mensaje de Bienvenida"
    subtitle="Envía un saludo automático a cada nuevo cliente — por WhatsApp o por correo"
    icon={<HandMetal className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-emerald-500" />}
    feature="Mensaje de Bienvenida"
    defaultTemplate="¡Hola @nombre! 🎉 Bienvenido a @negocio. Ganaste @puntos puntos de bienvenida (saldo: @saldo). ¡Gracias por registrarte!"
    variables={[
      { key: '@nombre', label: 'Nombre del cliente', example: 'María' },
      { key: '@negocio', label: 'Nombre de tu negocio', example: 'tu negocio', aliases: ['@marca'] },
      { key: '@sucursal', label: 'Sucursal donde compró (si no hay, el nombre del negocio)', example: 'Sucursal Centro' },
      { key: '@puntos', label: 'Puntos de bienvenida ganados', example: '10' },
      { key: '@saldo', label: 'Saldo total', example: '10', aliases: ['@total'] },
    ]}
    allowImage
    emailChannel={{ defaultSubject: '¡Bienvenido a tu programa de lealtad! 🎉' }}
    enabledHint={{ on: 'Los nuevos clientes recibirán un mensaje de bienvenida', off: 'Activar para enviar bienvenida a nuevos registros' }}
    stepGuide={{
      description: 'Cuando un nuevo cliente se registra (kiosco, panel o alta manual), el sistema envía el mensaje de bienvenida automáticamente por el canal que elijas.',
      steps: ['Cliente se registra', 'Sistema detecta registro', 'Mensaje enviado'],
    }}
    requirementsReady="Todo listo — los nuevos clientes recibirán su bienvenida automáticamente"
  />
);

export default WelcomeMessagePage;
